import { useState, useCallback, useRef } from 'react';

const useQuery = config => {
  const isFilteringRef = useRef(false);
  const [queries, setQueries] = useState(config);

  const handlePageChange = useCallback(activePage => {
    setQueries(prevState => ({
      ...prevState,
      skip: activePage * parseInt(prevState.limit)
    }));
  }, []);

  const handleSort = useCallback(({ column, direction }) => {
    setQueries(prevState => {
      if (prevState.orderBy === column && prevState.sortBy === direction) return prevState;
      return {
        ...prevState,
        orderBy: column,
        sortBy: direction
      };
    });
  }, []);

  const handleSearch = value => {
    console.log('value in search => ', value);
  };

  const handleFilterChange = evt => {
    isFilteringRef.current = true;
    if (!evt.target) {
      const value = evt.value;

      setQueries(prevState => ({
        ...prevState,
        [evt.name]: value,
        skip: 0
      }));
    } else {
      const value = evt.target.value;
      setQueries(prevState => ({
        ...prevState,
        [evt.target.name]: value,
        skip: 0
      }));
    }
  };

  return {
    handlePageChange,
    handleSort,
    handleFilterChange,
    handleSearch,
    queries,
    setQueries,
    isFilteringRef
  };
};

export default useQuery;
